import { TOMCAT_URL } from 'src/common';

export async function checkSessionCookies(): Promise<boolean> {
    const options: RequestInit = {
        credentials: 'include',
        cache: 'no-store',
    };

    try {
        // set a session attribute
        await fetch(`${TOMCAT_URL}public/cookie-probe`, options);

        // check if the attribute was set
        const response = await fetch(`${TOMCAT_URL}public/cookie-probe`, options);
        if (!response.ok) return false;

        const { sameSession } = await response.json();
        return sameSession === true;
    } catch (error) {
        console.error('Failed to fetch cookie-probe', error);
        return false;
    }
}
